import { create } from "zustand";

export const useBannerStore = create((set) => ({
  bannerList: {},
  headerMenu: [],
  lnbEsg: [],
  lnbCsboard: [],
  lnbSmallPrint: [],
  mainAward: [],
  mainStripe: [],
  mainImageStripe: [],
  customSm: [],
  customLg: [],
  interview: [],
  mainBtmM: [],
  mainBtmS: [],
  mainBtmFirstRowLeft: [],
  mainBtmFirstRowCenter: [],
  mainBtmFirstRowRight: [],
  mainBtmSecondRowLeft: [],
  mainBtmSecondRowCenter: [],
  mainBtmSecondRowRight: [],
  mainBtmThirdRowLeft: [],
  mainBtmThirdRowCenter: [],
  mainBtmThirdRowRight: [],
  mainBtmThirdCenter: [],
  mainBtmThirdLeft: [],
  mainBtmThirdRight: [],
  mainBtmWideSmall: [],
  mainEventStripe: [],
  mainSide: [],
  mainTop: [],
  mainTopCenterEvent: [],
  mainTopEvent: [],
  mobileBtm: [],
  prodLeftBtm: [],
  pageOut: [],

  setBannerList: (data) =>
    set(() => ({
      bannerList: data,
      headerMenu: data.header_menu || [],
      lnbEsg: data.lnb_esg || [],
      lnbCsboard: data.lnb_csboard || [],
      lnbSmallPrint: data.lnb_smallPrint || [],
      mainAward: data.main_award || [],
      mainStripe: data.main_stripe || [],
      mainImageStripe: data.main_image_stripe || [],
      customSm: data.custom_sm || [],
      customLg: data.custom_lg || [],
      interview: data.interview || [],
      mainBtmM: data.main_btm_m || [],
      mainBtmS: data.main_btm_s || [],
      mainBtmFirstRowLeft: data.main_btm_first_row_left || [],
      mainBtmFirstRowCenter: data.main_btm_first_row_center || [],
      mainBtmFirstRowRight: data.main_btm_first_row_right || [],
      mainBtmSecondRowLeft: data.main_btm_second_row_left || [],
      mainBtmSecondRowCenter: data.main_btm_second_row_center || [],
      mainBtmSecondRowRight: data.main_btm_second_row_right || [],
      mainBtmThirdRowLeft: data.main_btm_third_row_left || [],
      mainBtmThirdRowCenter: data.main_btm_third_row_center || [],
      mainBtmThirdRowRight: data.main_btm_third_row_right || [],
      mainBtmThirdCenter: data.main_btm_third_center || [],
      mainBtmThirdLeft: data.main_btm_third_left || [],
      mainBtmThirdRight: data.main_btm_third_right || [],
      mainBtmWideSmall: data.main_btm_wide_small || [],
      mainEventStripe: data.main_event_stripe || [],
      mainSide: data.main_side || [],
      mainTop: data.main_top || [],
      mainTopCenterEvent: data.main_top_center_event || [],
      mainTopEvent: data.main_top_event || [],
      mobileBtm: data.mobile_btm || [],
      prodLeftBtm: data.prod_left_btm || [],
      pageOut: data.page_out || [],
    })),
}));
